import React, { useEffect, useState, useRef, Fragment } from 'react';

import './index.scss'

import history from '../../History'
import TopEnterTips from '../Components/TopEnterTips'
import TencentDialog from '../Components/BindTencentDialog'
import BindResultDialog from '../Components/BindResultDialog'
import Dialog from '../../Components/Dialog'
import {getAllUrlParams, json2keyval, getQueryString} from '../../Utils/Utils'
import { createHashHistory } from 'history'
import SearchSingerClaim from '../Components/SearchSingerClaim'
import e from '../../Utils/Event'

export default function EnterChoose() {
  // 绑定结果弹窗
  const [bindDialogVisible, setBindDialogVisible] = useState(false)
  const [resultDialogVisible, setResultDialogVisible] = useState(false)
  const [resultStatus, setResultStatus] = useState(2)

  //结果传参
  const [info, setInfo] = useState({})

  //绑定搜索
  const [checkSingerName, setCheckSingerName] = useState('')
  const searchRef = useRef(null)
  const [showCancelBtn, setShowCancelBtn] = useState(false)

  //提示弹窗
  const [showTipsDialog, setShowTipsDialog] = useState(false)
  const [tipsContent, setTipsContent] = useState('')

  //http://mtp.kugou.net/clientmanage_v2/pms/show?type=show_record&id=34808#terminal_11
  //主动搜索，认领对应歌手
  const [singerName, setSingerName] = useState('')
  const [singerId, setSingerId] = useState('')
  const [claimSinger, setClaimSinger] = useState(false)

  //处理绑定结果
  function resultOp(status, info) {
    setInfo(info)
    setResultStatus(status)
    setBindDialogVisible(false)
    setResultDialogVisible(true)
  }
  //处理绑定结果
  function controlSetBindDialogVisible(visible) {
    // if (!visible) {
    //   setBindDialogVisible(false)
    // }
    setResultDialogVisible(visible)
  }

  //提示弹窗
  function showTips(word) {
    setTipsContent(word)
    setShowTipsDialog(true)
  }

  const config = [{
    icon: 'https://webimg.kgimg.com/166af12ed6301cced890dac8c51b7966.png',
    title: '音乐人',
    to: '/singer-enter',
    alt: '音乐人'
  },
  {
    icon: 'https://webimg.kgimg.com/5e296c75827f9a6755f6e0cb4190babd.png',
    title: '校园音乐人',
    desc: '审核更快捷',
    to: '/college-enter',
    alt: '校园音乐人'
  }]
  const config2 = [{
    icon: 'https://webimg.kgimg.com/5cbf9ae5e3d8e4ad70e7b701ab6e3692.png',
    title: '作词/作曲/Remix',
    to: '/cq-remix-enter',
    alt: '作词/作曲/Remix'
  }]
  const config3 = [{
    icon: 'https://webimg.kgimg.com/dffde434c84ef3ffc3efd7b628a1630d.png',
    title: '厂牌/唱片公司',
    to: '/organization',
    alt: '厂牌/唱片公司'
  }]
  const config4 = [{
    icon: 'https://webimg.kgimg.com/4f33521e00d27de0ab6d4a8c0aa24131.png',
    title: '查看是否被收录',
    to: '/organization',
    alt: '查看是否被收录'
  }]

  function goToPage(path) {
    if(path === '/singer-enter'){
      e.emit('selector', {
        title: '歌手入驻',
        options: [
          { value: 0, label: '原创' },
          { value: 1, label: '翻唱' },
        ],
        change: item =>{
          if(item.value === 0){
            goToPage('/enter-origin')
          }else if(item.value === 1){
            goToPage('/enter-re')
          }
        }
      })
      return;
    }

    if(path === '/college-enter'){
      window.pushBI({
        a: 24303,
        ft: '校园音乐人入驻入口',
        r: '音乐人入驻',
        svar1: '移动端'
      });
      e.emit('selector', {
        title: '校园音乐人',
        options: [
          { value: 0, label: '原创' },
          { value: 1, label: '翻唱' },
        ],
        change: item =>{
          if(item.value === 0){
            goToPage('/college-enter-origin')
          }else if(item.value === 1){
            goToPage('/college-enter-re')
          }
        }
      })
      return;
    }

    if(path === '/cq-remix-enter'){
      e.emit('selector', {
        title: '创作人入驻',
        options: [
          { value: 0, label: '作词/作曲' },
          { value: 1, label: 'Remix' }
        ],
        change: item =>{
          if(item.value === 0){
            goToPage('/cq-enter')
          }else if(item.value === 1){
            goToPage('/re-create')
          }
        }
      })
      return;
    }

    //原创1 翻唱2 词曲3 校园原创4 校园翻唱5
    if(path === '/enter-origin'){
      path = '/enter'
      localStorage.setItem(`enter-musician-${window.$userInfo.userid}`, '1')
    }
    if(path === '/enter-re'){
      path = '/enter'
      localStorage.setItem(`enter-musician-${window.$userInfo.userid}`, '2')
    }
    if(path === '/cq-enter'){
      path = '/enter'
      localStorage.setItem(`enter-musician-${window.$userInfo.userid}`, '3')
    }
    if(path === '/college-enter-origin'){
      path = '/enter'
      localStorage.setItem(`enter-musician-${window.$userInfo.userid}`, '4')
    }
    if(path === '/college-enter-re'){
      path = '/enter'
      localStorage.setItem(`enter-musician-${window.$userInfo.userid}`, '5')
    }
    console.log('logType', localStorage.getItem(`enter-musician-${window.$userInfo.userid}`))

    //跳转处理
    window.$getUserStatus(({ status, users }) => {
      if (path === '/enter') {
        // 入驻成功的，直接跳转去数据页
        if (~[1, 3, 4, 21, 31].indexOf(status)) {
          //透传所有url参数
          let params = getAllUrlParams();
          window.location.replace('https://h5.kugou.com/musicianService/v-6d9959c0/index.html?type=1&norule=1'+(Object.keys(params).length?'&'+json2keyval(params):''))
          return;
        }
        path = path + '/' + window.encodeURIComponent(JSON.stringify({ status }))
        history.go(path)
      }
      
      //非注销机构
      let findItem = users && JSON.stringify( users ) !== '{}' && users.find( ele => ( ele.role === 2 ) && ( ele.status !== -1 ) );
      //机构入驻
      if (path === '/organization') {
        if ( findItem ) {
          //mobileCmd.savePreReturnPage
          window.LC.mobileCall(710, { type: 1 });
          //已入驻机构身份,直接跳过去
          window.location.replace( 'https://activity.kugou.com/vo-activity/bd0c1520-722a-11ea-bd83-e73dc97ba287/index.html' )
          return;
        }else{
          showTips( '请前往电脑端输入网址：musician.kugou.com 进行机构入驻' )
        }
        return;
      }

      if(path === '/re-create'){
        window.pushBI({
          a: 23295,
          ft: '音乐人入驻',
          r: 'remix入驻入口',
          channel: 'H5'
        })
        setTimeout(() => {
          //透传所有url参数
          let params = getAllUrlParams();
          window.location.replace('https://h5.kugou.com/apps/musician-dj-enter/build/index.html?t=1'+(Object.keys(params).length?'&'+json2keyval(params):'')+'/#/enter'+ window.encodeURIComponent(JSON.stringify({ status: 0 })))
        }, 300);
        return;
      }
    })
  }

  function checkIfRecord(e) {
    let value = e ? e.target.value : checkSingerName

    if (!value.trim()) {
      return window.$Msg('请先输入歌手名字')
    }
    let iconRule1 = /[`~!@#$%^&*()_\-+=<>?:"{}|,\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/im
    let iconRule2 = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig
    if (iconRule1.test(value) || iconRule2.test(value)) {
      return window.$Msg('请不要输入特殊字符')
    }
    if (value.length > 60) {
      return window.$Msg('歌手名字请控制在60字内')
    }
    var name = window.encodeURIComponent(value)
    createHashHistory().push('/get-singer-list/' + name)
  }

  function claim(){
    e.emit('selector', {
      title: '认领',
      options: [
        { value: 0, label: '音乐人' },
        { value: 1, label: '校园音乐人' },
      ],
      change: item =>{
        if(item.value === 0){
          //认领的不用区分，因为不用上传作品
          localStorage.removeItem(`enter-musician-${window.$userInfo.userid}`)
          setShowCancelBtn(true)
          searchRef && searchRef.current && searchRef.current.focus()
        }else if(item.value === 1){
          localStorage.setItem(`enter-musician-${window.$userInfo.userid}`, '4')
          setShowCancelBtn(true)
          searchRef && searchRef.current && searchRef.current.focus()
        }
      }
    })
  }

  useEffect(() => {
    //searchRef.current.onsearch = checkIfRecord
    const searchClaimFn = ()=>{
      let claimSinger = getQueryString('claimSinger');
      let singerName = getQueryString('singerName');
      let singerId = getQueryString('singerId');
      if( claimSinger && singerName && singerId ){
        setClaimSinger(true)
        setSingerId(singerId)
        setSingerName(singerName)
      }
    }
    searchClaimFn();
    let showSearch = getQueryString( 'showSearch' );
    if ( showSearch ){
      setShowCancelBtn( true )
      //左上角点击退出
      window.LC.mobileCall(710, { type: 0 })
      if ( window.LC.isInClient() ) {
        window.$mustLogin( () => {} )
      }
    }
    window.pushBI({
      a: 24302,
      b: '曝光',
      ft: '校园音乐人入驻首页',
      r: '音乐人入驻',
      svar1: '移动端'
    });
  }, [])

  useEffect(() => {
    if(showCancelBtn){
      searchRef.current.onsearch = checkIfRecord
    }
  }, [showCancelBtn])

  return (<div className="EnterChoose" onClick={e => {
    if (!showCancelBtn) return;
    /* if (~Array.prototype.indexOf.call(e.target.classList, 'EnterChoose')) {
      setShowCancelBtn(false)
    } */
  }}>

    {!window.$noBindDialog && <TopEnterTips type="enter-choose-bind" tab={() => {
      window.pushBI({
        a: 21393,
        ft: '音乐人入驻',
        r: '手机页立即绑定'
      });
      setBindDialogVisible(true)
    }} />}
    
    {claimSinger && <SearchSingerClaim singerId={singerId} singerName={singerName}></SearchSingerClaim>}

    <div className="container">
      {/* 新做的认领模块 */}
      {/* ios上只有用户交互触发的focus事件才会起效 */}
      <section className={`toClaim ${showCancelBtn ? 'show':'hide'}`}>
        <p className="title">认领</p>
        <form action="" onSubmit={e => e.preventDefault()}>
          <input id="searchInput" className="check" value={checkSingerName} placeholder="查看是否被收录，仅需2步即可入驻"
            type="search" ref={searchRef} onChange={e => setCheckSingerName(e.target.value)} onFocus={() => {
              setShowCancelBtn(true)
            }}></input>
          <div className="searchIcon" onClick={e => checkIfRecord()}></div>
          {showCancelBtn && <div className="del" onClick={() => {
            setCheckSingerName('')
            setShowCancelBtn(false)
          }}>取消</div>}
        </form>
      </section>

      {!showCancelBtn && <Fragment>
        {/* 入驻相关模块 */}
        <p className="enterTitle">歌手入驻(有原创/翻唱歌曲的音乐人)</p>
        <div>
          {config.map((ele, index) => (<section key={index} className="item" onClick={() => goToPage(ele.to)}>
            <img src={ele.icon} alt={ele.alt}  onError={e=>{
              e.target.parentNode.classList.add('imgError')
              e.target.remove()
            }}/>
            <p className={"title" + (ele.subTitle ? ' parallel' : '')}>{ele.title}</p>
            {ele.desc && <p className="desc">{ele.desc}</p>}
            {ele.subTitle && <p className="subTitle">{ele.subTitle}</p>}
          </section>))}
        </div>
        <p className="enterTitle">创作人入驻</p>
        <div>
          {config2.map((ele, index) => (<section key={index} className="item" onClick={() => goToPage(ele.to)}>
            <img src={ele.icon} alt={ele.alt} onError={e=>{
              e.target.parentNode.classList.add('imgError')
              e.target.remove()
            }}/>
            <p className={"title" + (ele.subTitle ? ' parallel' : '')}>{ele.title}</p>
            {ele.desc && <p className="desc">{ele.desc}</p>}
            {ele.subTitle && <p className="subTitle">{ele.subTitle}</p>}
          </section>))}
        </div>
        <p className="enterTitle">机构入驻</p>
        <div>
          {config3.map((ele, index) => (<section key={index} className="item" onClick={() => goToPage(ele.to)}>
            <img src={ele.icon} alt={ele.alt}  onError={e=>{
              e.target.parentNode.classList.add('imgError')
              e.target.remove()
            }}/>
            <p className={"title" + (ele.subTitle ? ' parallel' : '')}>{ele.title}</p>
            {ele.desc && <p className="desc">{ele.desc}</p>}
            {ele.subTitle && <p className="subTitle">{ele.subTitle}</p>}
          </section>))}
        </div>

        <p className="enterTitle">认领</p>
        <div>
          {config4.map((ele, index) => (<section key={index} className="item" onClick={() => claim()}>
            <img src={ele.icon} alt={ele.alt}  onError={e=>{
              e.target.parentNode.classList.add('imgError')
              e.target.remove()
            }}/>
            <p className={"title" + (ele.subTitle ? ' parallel' : '')}>{ele.title}</p>
            {ele.desc && <p className="desc">{ele.desc}</p>}
            {ele.subTitle && <p className="subTitle">{ele.subTitle}</p>}
          </section>))}
        </div>

        {/* 新做的单独绑定模块，当用户为50状态身份时，不显示绑定入口 隐藏：20210325*/}
        {/* {!window.$noBindDialog&&<section className="toBind">
          <p className="title">已入驻腾讯音乐人</p>
          <div className="btnContainer" onClick={() => {
              window.pushBI({
                a: 21393,
                ft: '音乐人入驻',
                r: '手机页立即绑定'
              });
              setBindDialogVisible(true)
            }}>
            <p className="desc">绑定手机号码即可</p>
            <div className="btn">立即绑定</div>
          </div>
        </section>} */}
      </Fragment>}
    </div>
    <Dialog title="提示" visible={showTipsDialog} setVisible={setShowTipsDialog} btns={[{ text: '知道了', fn: () => setShowTipsDialog(false) }]}>
      <div className="dialogText">{tipsContent}</div>
    </Dialog>
    <TencentDialog visible={bindDialogVisible} setVisible={setBindDialogVisible} result={resultOp} />
    <BindResultDialog visible={resultDialogVisible} setVisible={controlSetBindDialogVisible} status={resultStatus} info={info} />
  </div>)
} 